import React from 'react';
import MemberWrapper from './member-wrapper';
import PermissionCapabilities from './permission-capabilities';
import NotificationPreferences from './notification-preferences';
import LogAccessSummary from './log-access-summary';
import MemberGroupList from './member-group-list';
import { accessLevel, groupAccessLevel, purgeLogsAccess } from '../helpers';

class EditableMember extends React.Component {
  render() {
    return (
      <MemberWrapper
        id={this.props.id}
        memberId={this.props.memberId}
        email={this.props.email}
        isCurrentMember={this.props.isCurrentMember}
        isEditAllForm={this.props.isEditAllForm}
        showDeleteButton={this.props.showDeleteButton}
        showEditButton={this.props.showEditButton}
        showFormButtons={this.props.showFormButtons}
        permissionsBoxCss={'mod-editable'}
        onSaveMemberChanges={this.props.onSaveMemberChanges}
        onEditMemberCancel={this.props.onEditMemberCancel}
        onDeleteMemberClick={this.props.onDeleteMemberClick}
        onEditMemberClick={() => {}}
        errorMessage={this.props.errorMessage}
        saveButtonText={this.props.saveButtonText}
        cancelButtonText={this.props.cancelButtonText}
      >
        <div className="grid flex">
          <PermissionCapabilities
            isEditable={!this.props.isCurrentMember}
            isVisible={!this.props.sso}
            memberId={this.props.memberId}
            manageMembers={this.props.manageMembers}
            manageBilling={this.props.manageBilling}
            hasLogAccess={this.props.hasLogAccess}
            onCheckboxChange={this.props.onCheckboxChange}
            onLogAccessChange={this.props.onLogAccessChange}
          />

          <NotificationPreferences
            isEditable={true}
            memberId={this.props.memberId}
            receiveUsageEmails={this.props.receiveUsageEmails}
            receiveBillingEmails={this.props.receiveBillingEmails}
            editableNotifications={this.props.editableNotifications}
            paysSomeoneElse={this.props.paysSomeoneElse}
            onCheckboxChange={this.props.onCheckboxChange}
          />
        </div>

        <LogAccessSummary
          isEditable={!this.props.isCurrentMember}
          isVisible={this.props.hasLogAccess && !this.props.sso}
          memberId={this.props.memberId}
          manageMembers={this.props.manageMembers}
          readOnly={this.props.readOnly}
          canAccessAllGroups={this.props.canAccessAllGroups}
          purgeLogs={this.props.purgeLogs}
          accessLevel={accessLevel}
          groupAccessLevel={groupAccessLevel}
          purgeLogsAccess={purgeLogsAccess}
          onCheckboxChange={this.props.onCheckboxChange}
          onBoolSelectChange={this.props.onBoolSelectChange}
          onLogAccessSelectChange={this.props.onLogAccessSelectChange}
        />

        <MemberGroupList
          isEditable={true}
          isVisible={this.props.hasLogAccess && !this.props.sso}
          memberId={this.props.memberId}
          email={this.props.email}
          canAccessAllGroups={this.props.manageMembers || this.props.canAccessAllGroups}
          groups={this.props.groups}
          groupIds={this.props.groupIds}
          onGroupCheckboxChange={this.props.onGroupCheckboxChange}
        />
      </MemberWrapper>
    );
  }
};

export default EditableMember;
